import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var banner = new Swiper('.section2 ul li .swiper', {
    autoplay: {
        delay: 1500,
        disableOnInteraction: false,
    },
    speed:500,
    loop:true,//必须
    pagination: {
      el: ".section2 ul li .swiper-pagination",
      clickable: true,
    },
}); 
const storySwiper = new Swiper('.section3 .swiper', {
    loop: true,  //使用无限循环会造成循环时闪烁问题，暂未解决
    centeredSlides: true,
    slidesPerView: 5,
    spaceBetween: 0,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    autoplay: {
        delay: 1500,
        disableOnInteraction: false,
    },
    speed:700,
    // 启用硬件加速
    willChangeOnTransition: true,
    on: {
        // 优化缩放逻辑：针对5张图的比例调整
        progress: function() {
            const swiper = this;
            for (let i = 0; i < swiper.slides.length; i++) {
                const slide = swiper.slides[i];
                const progress = slide.progress; // 进度值：中间为0，左侧为负，右侧为正
                
                // 缩放公式：中间（progress=0）最大为1，向两侧（progress±1、±2）逐渐缩小
                // 5张图时，两侧最远的图progress为±2，所以缩放比例更平缓
                let scale = 1 - Math.abs(progress) * 0.1; 
                // 限制最小缩放（避免过小导致模糊）
                scale = Math.max(scale, 0.8); 
                
                slide.style.transform = `scale(${scale})`;
                
            }
        },
    },
    // 响应式配置
    breakpoints: {
        // 当屏幕宽度 >= 320px时
        320: {
        slidesPerView: 1, // 每页显示1个幻灯片
        },
        // 当屏幕宽度 >= 640px时
        640: {
        slidesPerView: 3, // 每页显示3个幻灯片
        spaceBetween: 10, // 调整间距
        },
        // 当屏幕宽度 >= 992px时
        992: {
        slidesPerView: 3, // 每页显示3个幻灯片
        spaceBetween: 10, // 调整间距
        },
        // 当屏幕宽度 >= 1200px时
        1200: {
        slidesPerView: 5, // 每页显示5个幻灯片
        // spaceBetween: 10, // 调整间距
        }
    }
});

var Cooperation = new Swiper('.section5 ul li .swiper', {
    speed:5000,//匀速时间
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },
    loop:true,//必须
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        spaceBetween: 30,
        },
        768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: 10,
        }
    } 
}); 